function normalizeRoles(input?: string | string[] | null): string[] {
  if (!input) return [];
  const roles = Array.isArray(input) ? input : [input];
  return roles.map((role) => String(role).toUpperCase());
}

export function isAdminOrAbove(role?: string | string[] | null): boolean {
  const roles = normalizeRoles(role);
  return roles.includes('ADMIN') || roles.includes('SUPER_ADMIN') || roles.includes('ORG_ADMIN');
}

export function isFullAdmin(role?: string | string[] | null): boolean {
  const roles = normalizeRoles(role);
  return roles.includes('ADMIN') || roles.includes('SUPER_ADMIN');
}

export function isOrgAdmin(role?: string | string[] | null): boolean {
  return normalizeRoles(role).includes('ORG_ADMIN');
}

export function isSuperAdmin(role?: string | string[] | null): boolean {
  return normalizeRoles(role).includes('SUPER_ADMIN');
}
